import '../scss/main.scss';

import { siteHeader as initSiteHeader } from './interactive/siteHeader';
// import { dropdownMenus as initDropdownMenus } from './interactive/dropdownMenus';
import { navigationDropdowns as initDropdownMenus } from './interactive/navigationDropdowns';
import { carousels as initCarousels } from './content-blocks/carousels';
import { scrollingPanel as initScrollingPanel } from './interactive/scrollingPanel';
import { offscreenMenuToggle as initOffscreenMenu } from './interactive/offscreenMenuToggle';
import { closeTogglePanel as initCloseTogglePanel } from './interactive/closeTogglePanel';
import { handleBookingSubmission as initBookingSubmission } from './interactive/bookSiteVisit';
import { scrollToNextSection as initScrollToNextSection } from './interactive/scrollToContent';
import { scrollToTop as initScrollToTop } from './interactive/scrollToTop';
import { toggleLinks as initToggleLinks } from './interactive/toggleLinks';
import { scrollToAnchor as initScrollToAnchor } from './interactive/scrollToAnchor';
import { anchorPanel as initAnchorPanel } from './interactive/anchorPanel';
import { dialogs as initDialogs } from './interactive/dialogs';
import { handleFilters as filters } from './interactive/filters';
import { sectorCards as initSectorCards } from './content-blocks/sector-cards';
import { handlePostcodeLookup as initHandlePostcodeFinder } from './interactive/postcodeLookup';
import { handleMultiStepBooking as initHandleMultiStepBooking } from './interactive/multiStepBooking';
import { scrollToTarget as initScrollToTarget } from './interactive/scrollToTarget';
import { videoEmbeds as initVideoEmbeds } from './content-blocks/video-embed';
import { modals as initModals } from './interactive/modals';
import { revealAnimations as initRevealAnimations } from './interactive/revealAnimations';
import { tracking as initTrackingData } from './helpers/tracking';
import { initAccordion } from './content-blocks/accordion.js';

document.addEventListener("DOMContentLoaded", () => {
    initSiteHeader(document.querySelector('[data-js="site-header"]'));
    initDropdownMenus(document.querySelectorAll('[data-js="menu-toggle"]'));
    initCarousels(document.querySelectorAll('[data-js="carousel"]'));
    initScrollingPanel(document.querySelectorAll('[data-js="scrolling-panel"]', 0.4));
    initOffscreenMenu(document.querySelector('[data-js="site-nav-toggle"]'));
    initCloseTogglePanel(document.querySelectorAll('[data-js="close-panel-button"]'));
    initBookingSubmission(document.querySelector('[data-js="book-site-visit"]'));
    initScrollToNextSection(document.querySelectorAll('[data-js="scroll-to-content"]'));
    initDialogs(document.querySelectorAll('[data-dialog-trigger]'));
    initScrollToAnchor(document.querySelectorAll('[data-js="scroll-to-anchor"]'));
    initToggleLinks(document.querySelectorAll('[data-js="toggle-link"]'));
    initScrollToTop(document.querySelectorAll('[data-js="scroll-to-top"]'));
    initAnchorPanel(document.querySelectorAll('[data-js="anchor-panel-toggle"]'));
    filters();
    initSectorCards(document.querySelectorAll('[data-js="sector-cards"]'));
    initHandlePostcodeFinder(document.querySelector('[data-js="postcode-lookup"]'));
    initHandleMultiStepBooking(document.querySelector('[data-js="booking-form"]'));
    initScrollToTarget(document.querySelectorAll('[data-js="scroll-to-target"]'));
    initVideoEmbeds(document.querySelectorAll('[data-js="video-embed"]'));
    initModals(document.querySelectorAll('.dialog-overlay'));
    initRevealAnimations(document.querySelectorAll('.reveal'));
    initTrackingData();

    // Better function call for accordions
    document.querySelectorAll('[data-block="accordion"]').forEach((accordion) => {
        initAccordion(accordion);
    });
});